// extracted by mini-css-extract-plugin
export var messageSideLeft = "_he-1";
export var messageSideRight = "_he-2";
export var subscribeToBackInStockBubbleContainer = "_he-0";